"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getThemeValOrFallback = getThemeValOrFallback;
var _kyruusUiTheme = _interopRequireDefault(require("./kyruus-ui-theme"));
var _fallbacks = _interopRequireDefault(require("./fallbacks"));
const defaultTheme = {};

/**
 * Loop through keys until find in defaultTheme or KyruusTheme object else returns null.
 * @param {object} theme - This can be defaultTheme or KyruusTheme.
 * @param {string} key - The value to get from the theme i.e color_button.
 * @param {object} fallbacks - The fallback keys object.
 * @returns {string} color hex value
 */
function getThemeValOrFallback(theme, key, fallbacks) {
  if (theme[key]) return theme[key];
  return fallbacks[key] ? getThemeValOrFallback(theme, fallbacks[key], fallbacks) : null;
}

/**
 * Utility for use with `styled` from @emotion/styled
 * Grabs the value from the current theme object, or
 * uses the default value from this package.
 * @param {string} key - The value to get from the theme.
 * @returns {function}
 */
const fromTheme = key => _ref => {
  let {
    theme = defaultTheme
  } = _ref;
  const getDefaultThemeVal = getThemeValOrFallback(theme, key, _fallbacks.default);
  if (getDefaultThemeVal) {
    return getDefaultThemeVal;
  } else {
    const getKyruusThemeVal = getThemeValOrFallback(_kyruusUiTheme.default, key, _fallbacks.default);
    if (getKyruusThemeVal) {
      return getKyruusThemeVal;
    } else if (process.env.NODE_ENV != 'production') {
      /*eslint-disable-next-line*/
      console.warn(`Unknown theme property: ${key}`);
    }
  }
};
var _default = exports.default = fromTheme;